"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Base64UrlDecode_1 = require("../utils/Base64UrlDecode");
var mobx_1 = require("mobx");
//const updateReason = new Enum(['apiCall', 'logOut', 'storageEvent'], { freeze: true });
var authTokenKey = "to-authtoken";
var timeDiffKey = "timediff";
var AuthorizationStore = /** @class */ (function () {
    function AuthorizationStore(rootStore) {
        var _this = this;
        this.token = localStorage.getItem('jwt');
        this.getToken = function () {
            return localStorage.getItem(authTokenKey) || "";
        };
        this.setToken = function (token) {
            var payload = _this.tokenPayload(token);
            if (payload.iat)
                _this.timeDiff = Math.ceil(Date.now() / 1000) - payload.iat; // Difference in seconds between client time (now) vs server time (when it created the token). Probably ~seconds for visitor in same timezone, +hours for timezones to the East, and -hours for timezones to the West.
            localStorage.setItem(authTokenKey, token);
            mobx_1.runInAction(function () {
                _this.token = token;
            });
            // The call below is probably no longer needed because we now trigger it through the iframe storage event handler, see below.
            //this.resetSessionTimers(token ? updateReason.apiCall : updateReason.logOut);
        };
        this.getExpirationDate = function () {
            var payload = _this.tokenPayload(_this.getToken());
            return payload.exp;
        };
        this.methodLeft = function () {
            var payload = _this.tokenPayload(_this.getToken());
            var difference = (payload.exp * 1000) - (Date.now());
            var timeLeft = {};
            _this.timeLeft = {
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        };
        // resetSessionTimers(reason) {
        //   // To see if this function gets triggered + if so, what triggered it:
        //   //console.log("resetSessionTimers(" + reason.key + ")");
        //   clearTimeout(window.warningTimeout);
        //   clearTimeout(window.logoutTimeout);
        //   const { iat: issuedAt, exp: expires } = this.tokenPayload();  // Get token values (and store into readable names).
        //   if (expires > 0) {
        //     const timeoutSeconds = expires - issuedAt - 1; // Values are in seconds. The "- 1" is there because the token has aged a little bit already when we process it.
        //     const warningSeconds = timeoutSeconds >= 180 ? 120 : timeoutSeconds / 2; // If token is valid for >= 180 sec then warn 120 sec before token expires (normal behaviour). For debugging we support shorter times, e.g. 20 sec validity -> 10 sec warning timeout.
        //     window.warningTimeout = setTimeout(() => sendCustomEvent(ServiceEvents.sessionWarning), (timeoutSeconds - warningSeconds) * 1000); // "Warning" dialog timer. If you change the 120 value, you also need to change the "2 minutes" in the warning text.
        //     window.logoutTimeout = setTimeout(() => sendCustomEvent(ServiceEvents.sessionLogout, { expires }), timeoutSeconds * 1000); // "Expired" dialog timer.
        //     sendCustomEvent(ServiceEvents.sessionStarted);
        //   }
        //   else if (expires === 0 && reason === updateReason.storageEvent) {
        //     sendCustomEvent(ServiceEvents.sessionLogout, { expires });
        //   }
        // }
        this.tokenParts = function (token) {
            return (token || _this.getToken()).split(".");
        };
        this.tokenPayload = function (token) {
            var parts = _this.tokenParts(token);
            return parts.length === 3
                ? JSON.parse(Base64UrlDecode_1.base64UrlDecode(parts[1]))
                : { exp: 0 };
        };
        this.isDateValid = function (payload) {
            return Math.ceil(Date.now() / 1000) - _this.timeDiff <= payload.exp;
        };
        this.isAuthenticated = function () {
            return _this.isDateValid(_this.tokenPayload(_this.getToken()));
        };
        this.rootStore = rootStore;
        this.timeLeft = this.calculateTimeLeft;
        mobx_1.makeAutoObservable(this);
        mobx_1.reaction(function () { return _this.token; }, function (token) {
            console.log(token);
        });
    }
    Object.defineProperty(AuthorizationStore.prototype, "timeDiff", {
        get: function () {
            var value = localStorage.getItem(timeDiffKey);
            return value ? parseInt(value) : 0;
        },
        set: function (value) {
            localStorage.setItem(timeDiffKey, String(value));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthorizationStore.prototype, "calculateTimeLeft", {
        get: function () {
            return this.timeLeft;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthorizationStore.prototype, "roleId", {
        get: function () {
            var payload = this.tokenPayload(this.getToken());
            return this.isDateValid(payload)
                ? payload["ImpersonationList"].split(",")[0]
                : "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthorizationStore.prototype, "role", {
        get: function () {
            var payload = this.tokenPayload(this.getToken());
            return this.isDateValid(payload)
                ? payload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"].toLowerCase()
                : "";
        },
        enumerable: false,
        configurable: true
    });
    AuthorizationStore.prototype.isInRole = function (role) {
        return role && this.role === role.toLowerCase();
    };
    // isInRoles(roles: any) {
    //   return roles && roles.some(r => isRoleMatch(this.role, r));
    // }
    AuthorizationStore.prototype.hasRole = function () {
        return this.role.length > 0;
    };
    AuthorizationStore.prototype.roleNamesFrom = function (payload, startIndex) {
        var roleNames = payload["ImpersonationRoleNames"].toLowerCase().split(",");
        return startIndex > 0
            ? roleNames.slice(startIndex)
            : roleNames;
    };
    return AuthorizationStore;
}());
exports.default = AuthorizationStore;
//# sourceMappingURL=AuthorizationStore.js.map